/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { useStateValue } from '../ContextApi/StateProvider';
import { Redirect } from 'react-router-dom';
import Form from './Form';
import './components.css';

const WorkoutEdit = (props) => {
    const [id, setId] = useState(null);
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [time, setTime] = useState("");
    const [errors, setErrors] = useState([]);
    const [initialState] = useStateValue();
    const authUser = JSON.parse(initialState.authenticatedUser);

    useEffect(() => {
        initialState.WorkoutRequests.getWorkout(
            props.match.params.id,
            authUser.emailAddress,
            authUser.password
        )
            .then((response) => {
                setId(response.id);
                setTitle(response.title);
                setDescription(response.description);
                setTime(response.time);
            })
            .catch((err) => {
                console.log('Error: ' + err);
            });
    }, []);

    const change = (event, setState) => {
        const value = event.target.value;
        setState(value);
    };

    const submit = () => {
        const workout = { id, title, description, time };

        initialState.WorkoutRequests.updateWorkout(
            workout,
            authUser.emailAddress,
            authUser.password
        )
            .then((response) => {
                if (response === "success") {
                    console.log(`${authUser.emailAddress} successfully edited workout ${workout}`);
                    props.history.push(`/workouts/${props.match.params.id}`);
                } else if (response === "forbidden") {
                    setErrors([...errors, "You must be logged in to edit a workout."]);
                } else {
                    setErrors([...errors, response]);
                    console.log(errors);
                }
            })
            .catch((err) => {
                setErrors([...errors, err]);
            });
    };

    const cancel = () => {
        props.history.push(`/workouts/${props.match.params.id}`);
    };

    if (!authUser) {
        return <Redirect to="/sign-in" />;
    }

    return (
        <div className="container-2025 section-2025 prose-2025">
            <div className="grid-2025">
                <Form
                    cancel={cancel}
                    cancelButtonText="Back"
                    submit={submit}
                    submitButtonText="Update Workout"
                    elements={() => (
                        <>
                            <h2 className="form-header">
                                <i className="fas fa-newspaper"></i> Edit Workout
                            </h2>

                            {errors.map((error, i) => (
                                <p key={i} className="workout-error-message">{error}</p>
                            ))}

                            <div className="form-row">
                                <label htmlFor="title" className="form-label">
                                    Title
                                </label>
                                <input
                                    id="title"
                                    name="title"
                                    type="text"
                                    onChange={(e) => change(e, setTitle)}
                                    value={title}
                                    maxLength="18"
                                    required
                                    className="input-2025"
                                />
                            </div>

                            <div className="form-row">
                                <label htmlFor="description" className="form-label">
                                    Description
                                </label>
                                <input
                                    id="description"
                                    name="description"
                                    type="text"
                                    onChange={(e) => change(e, setDescription)}
                                    value={description}
                                    required
                                    className="input-2025"
                                />
                            </div>
                        </>
                    )}
                />
            </div>
        </div>
    );
};

export default WorkoutEdit;